<template>
  <div id="app-scc">
    <header-scc v-if="showContent"/>
    <div id="content-footer">
      <transition name="page-fade">
        <message-box
            v-show = "dataMessageBox.showMessageBox"
            class = "message-box"
            :show-message="dataMessageBox.showMessageBox"
            :type-color="dataMessageBox.typeColor"
            :text-message="dataMessageBox.textMessage"
        />
      </transition>

      <div id="content">
        <div id="container-spinner-content">
          <loading-spinner
              :active.sync="showSpinner"
              loader="spinner"
              :is-full-page="fullPage"
          />

          <transition name="page-fade" v-if="childDataLoaded">

            <router-view  v-if="showContent"/>
          </transition>
        </div>
      </div>
      <footer-css v-if="showContent"/>
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import HeaderScc from "./components/headerScc/headerScc";
import FooterCss from "./components/footerCss"
import messageBox from "./components/elements/messageBox";
import moment from "moment-timezone";
import xlooLib from "./librarys/xlooLib";

import Vue from 'vue'
import { VueReCaptcha } from "vue-recaptcha-v3";
import store from '@/store'

import axios from 'axios'

export default {
  name: 'App',
  components: {
    HeaderScc,
    FooterCss,
    messageBox,
  },
  data() {
    return {
      showContent: false,
      childDataLoaded: false,
      showSpinner: false,
      isLoading: false,
      fullPage: true,
      dataMessageBox: {
        showMessageBox: false,
        typeColor: 'danger',
        textMessage: '',
      }
    }
  },
  computed: {
    ...mapState({
      siteCustomizationData: state => state.settingsAndCustomize.siteCustomizationData,
      siteSittingsData: state => state.settingsAndCustomize.donorPortalSettings,
      authDonor: state => state.auth.authDonor,
      csrfToken: state => state.auth.csrfToken,

    }),
    ...mapGetters('settingsAndCustomize', ['GET_configurationSiteUrlSite']),
  },
  watch: {
    authDonor() {
      this.dhqLife()
    }
  },
  async created() {
    let scc = this
    this.$root.$on("showSpinner", () => {
      scc.showSpinner = true;
    })
    this.$root.$on("hideSpinner", () => {
      scc.showSpinner = false;
    })
    this.$root.$on("messageBox",({timeShow, typeColor, textMessage}) => {
      scc.showMessageBox(timeShow, typeColor, textMessage)
    })
    this.$root.$on("closeMessageBox",() => {
      scc.dataMessageBox.showMessageBox = false
      scc.dataMessageBox.textMessage = ''
    })

    axios.interceptors.request.use(
        config => {
          if (this.csrfToken !== '' && xlooLib.getCookie('auth')) {
            config.headers['X-CSRF-TOKEN'] = this.csrfToken
          }
          return config
        },
        error => Promise.reject(error)
    )

    axios.interceptors.response.use(
        response => response,
        async error => {
          if (error.response) {
            switch (error.response.status) {
              case 401:
                console.log('401 – error. Log out')
                this.showSpinner = true

                await store.dispatch('auth/SET_logout', 'standard')
                break
              case 403:
                console.log('403 – error')
                break
              case 500:
                console.log('500 – error')
                break
              default:
                console.log('Request error')
            }
          }
          return Promise.reject(error)
        }
    )

    this.showSpinner = true
    await this.$store.dispatch("settingsAndCustomize/SET_getSiteCustomization")
    await this.$store.dispatch("settingsAndCustomize/SET_getSiteSettings")
    await this.$store.dispatch("settingsAndCustomize/SET_bookingInfo")
    this.customStyle()
    await this.$store.dispatch("auth/SET_restartLoginDonor");

    this.childDataLoaded = true

    if (
        this.siteSittingsData.captchaSettings.recaptcha.enable === '1' &&
        this.siteSittingsData.captchaSettings.recaptcha.siteKey !== ''
    ){
      await Vue.use(VueReCaptcha, {
        siteKey: this.siteSittingsData.captchaSettings.recaptcha.siteKey,
        autoHideBadge: true,
      });
    }

    this.showContent = true
    this.showSpinner = false
  },
  mounted() {

  },
  methods: {
    customStyle() {
      document.getElementById('app-scc').style.setProperty("--BasicFontColor", this.siteCustomizationData.colorAndFonts.colorBasicFont);
      document.getElementById('app-scc').style.setProperty("--BasicFont", this.siteCustomizationData.colorAndFonts.basicFont);
      document.getElementById('app-scc').style.setProperty("--ButtonColor", this.siteCustomizationData.colorAndFonts.colorButton);
      document.getElementById('app-scc').style.setProperty("--ButtonTextHover", this.siteCustomizationData.colorAndFonts.colorButtonHover);
    },
    showMessageBox(timeShow, typeColor, textMessage) {
      this.dataMessageBox.showMessageBox = true
      this.dataMessageBox.typeColor = typeColor
      this.dataMessageBox.textMessage = textMessage

      if (typeof timeShow === 'number' && timeShow > 0) {
        let scc = this
        setTimeout(() => {
          scc.dataMessageBox.showMessageBox = false
          scc.dataMessageBox.typeColor = typeColor
          scc.dataMessageBox.textMessage = ''
        }, timeShow);
      }
    },
    dhqLife() {
      const timeL = xlooLib.getLocalStorage('time_update_token');

      let startDate = new Date();
      let stepTimeL = moment(timeL).diff(startDate, 's');
      if (stepTimeL < 0) {
        return false;
      }
    }
  }
}
</script>

<style>
/* @import '/assets/css/ressets-style.css';*/

@font-face {
/*  font-family: "ProximaNW01-Reg"; */
  font-family: "Proxima";
  src: url("~@/assets/externalFonts/ProximaNW01-Reg/55c4f556836775174bfac94178a3fe82.eot");
  src: url("~@/assets/externalFonts/ProximaNW01-Reg/55c4f556836775174bfac94178a3fe82.eot?#iefix") format("embedded-opentype"),
  url("~@/assets/externalFonts/ProximaNW01-Reg/55c4f556836775174bfac94178a3fe82.woff2") format("woff2"),
  url("~@/assets/externalFonts/ProximaNW01-Reg/55c4f556836775174bfac94178a3fe82.woff2") format("woff"),
  url("~@/assets/externalFonts/ProximaNW01-Reg/55c4f556836775174bfac94178a3fe82.ttf") format("truetype"),
  url("~@/assets/externalFonts/ProximaNW01-Reg/55c4f556836775174bfac94178a3fe82.svg") format("svg");
}
@font-face {
  font-family: "Poppins SemiBold";
  src: url("~@/assets/externalFonts/Poppins SemiBold/028b4cfdfab5d1049178e9b1eb42f49e.eot");
  src: url("~@/assets/externalFonts/Poppins SemiBold/028b4cfdfab5d1049178e9b1eb42f49e.eot") format("embedded-opentype"),
  url("~@/assets/externalFonts/Poppins SemiBold/028b4cfdfab5d1049178e9b1eb42f49e.woff2") format("woff2"),
  url("~@/assets/externalFonts/Poppins SemiBold/028b4cfdfab5d1049178e9b1eb42f49e.woff") format("woff"),
  url("~@/assets/externalFonts/Poppins SemiBold/028b4cfdfab5d1049178e9b1eb42f49e.ttf") format("truetype"),
  url("~@/assets/externalFonts/Poppins SemiBold/028b4cfdfab5d1049178e9b1eb42f49e.svg#Poppins SemiBold") format("svg");
}
@font-face {
  font-family: "Poppins";
  src: url("~@/assets/externalFonts/Poppins/07ecc0aa9ce268962dea7356eeff50a6.eot");
  src: url("~@/assets/externalFonts/Poppins/07ecc0aa9ce268962dea7356eeff50a6.eot?#iefix") format("embedded-opentype"),
  url("~@/assets/externalFonts/Poppins/07ecc0aa9ce268962dea7356eeff50a6.woff2") format("woff2"),
  url("~@/assets/externalFonts/Poppins/07ecc0aa9ce268962dea7356eeff50a6.woff") format("woff"),
  url("~@/assets/externalFonts/Poppins/07ecc0aa9ce268962dea7356eeff50a6.ttf") format("truetype"),
  url("~@/assets/externalFonts/Poppins/07ecc0aa9ce268962dea7356eeff50a6.svg") format("svg");
}
@font-face {
  /*font-family: "Avenir Heavy";*/
  font-family: "AvenirHeavy";
  src: url("~@/assets/externalFonts/Avenir Heavy/901497541657a2f24e42848bcf7fad52.eot");
  src: url("~@/assets/externalFonts/Avenir Heavy/901497541657a2f24e42848bcf7fad52.eot?#iefix") format("embedded-opentype"),
  url("~@/assets/externalFonts/Avenir Heavy/901497541657a2f24e42848bcf7fad52.woff2") format("woff2"),
  url("~@/assets/externalFonts/Avenir Heavy/901497541657a2f24e42848bcf7fad52.woff") format("woff"),
  url("~@/assets/externalFonts/Avenir Heavy/901497541657a2f24e42848bcf7fad52.ttf") format("truetype"),
  url("~@/assets/externalFonts/Avenir Heavy/901497541657a2f24e42848bcf7fad52.svg#Avenir Heavy") format("svg");
}
@font-face {
  /*font-family: 'Oswald Regular';*/
  font-family: 'Oswald';
  src: url('~@/assets/externalFonts/font-oswald/Oswald-Regular.eot');
  src: url('~@/assets/externalFonts/font-oswald/Oswald-Regular.eot?#iefix') format('embedded-opentype'),
  url('~@/assets/externalFonts/font-oswald/Oswald-Regular.woff') format('woff'),
  url('~@/assets/externalFonts/font-oswald/Oswald-Regular.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

html {
  margin-right: calc(-1 * (100vw - 100%));
}

html body {
  margin: 0 calc(-1 * (100vw - 100%)) 0 0;
  font-size: 14px;
  font-weight: bold !important;
  overflow-x: hidden;
}

#app-scc {
  --BasicFontColor: #000;
  --BasicFont: proxima-n-w01-reg;
  --ButtonColor: #c9c76d;
  --ButtonTextHover: #000;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--BasicFontColor);
  display: flex;
  flex-direction: column;
  height: 100vh;

}
#app-scc header.header-css {
  font-family: var(--BasicFont);
}
#content-footer {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  font-family: var(--BasicFont);
}

#content {
  flex-grow: 1;
}

.section-scc-portal {
  padding-top: 40px;
  padding-bottom: 40px;
}

body .nowrap {
  flex-wrap: nowrap;
}

#pillow {
  height: 120px;
}

.hover-pointer:hover {
  cursor: pointer;
}

body h1, h2 {
  font-family: var(--BasicFont), Poppins, Poppins SemiBold, proxima-n-w01-reg, sans-serif;
  font-size: 25px;
  font-weight: bold;
}

body .label-form-css {
  color: inherit;
  font-size: 1rem;
}

body .button-section {
  display: flex;
  align-items: center;
  width: auto;
  min-height: 42px;
  max-width: 350px;
  border-radius: 0;
  border-color: var(--ButtonColor);
  color: inherit;
/*  font-family: "Avenir Heavy", sans-serif;*/
  font-family: var(--BasicFont);
  z-index: 90;
}

body .button-section:hover, .button-section:active {
  color: var(--ButtonTextHover);
  background-color: var(--ButtonColor);
  border-color: var(--ButtonColor);
  text-decoration: none;
}

body .container-item-form {
  max-width: 560px;
  margin: 10px 0 0 0;

}

body .container-input-form {
  margin-bottom: 35px;
  padding-left: 0;
  padding-right: 0;
  text-align: start;
}

body .container-input-form-left {
  padding-right: 10px;
}

body .form-control {
  appearance: auto;
  min-height: 38px;
}

.button-section svg {
  margin: 0 10px;
}

body .errorInput, body .invalid-item, body .invalid-item input {
  border-color: red;
}

.error-radio {
  border-color: red;
  color: red
}

.spinner {
  position: absolute;
  top: 250px;
  left: calc(50% - 24px);
  z-index: 9000;
}
#container-spinner-content .vld-overlay.is-full-page {
  z-index: 100000;
}

body .label-form-css {
  color: inherit;
  font-size: 1rem;
}

body #block-info-donation-site .container-input-form-left {
  margin-bottom: 10px;
  padding-bottom: 0;
}

body .container-input-form-left {
  padding-right: 10px;
}

body .scc_modal {
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 9999;
  background-color: #96989970;
  height: 100vh;
}

.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}

#container-spinner-content {
  position: relative;
}

#container-spinner-content .vld-overlay {
  position: fixed;
}

#container-spinner-content svg{
  stroke: var(--ButtonColor);
  fill: var(--ButtonColor);
}

#container-spinner-content circle {
  color: var(--ButtonColor);
}

#container-spinner-content .vld-icon {
  position: fixed;
  top: 30%;
}
.message-box{
  position: fixed;
  top: 6%;
  right: 0;
  left: 0;
  height: 100%;
  z-index: 1000;
}
.message-box .message-banner{
  text-align: center;
  opacity: 0.9;
}
.message-banner button, .message-box button{
  background-color: inherit;
  border-color: transparent;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 55px;
  font-size: 1.5rem;
}

.page-fade-enter-active {
  transition: all .5s ease;
}

.page-fade-enter, .page-fade-leave-to
{
  transform: translateX(5%);
  opacity: 0;
}

.grecaptcha-badge {
  visibility: hidden;
}
.social-icon{
  width: 80%;
}
.social-icon path {
  fill: #adb5bd;
}
.hover-item-a:hover .social-icon path {
  fill: var(--ButtonColor);
}
</style>
